export default {
  success: {
    recurrent: {
      cancel: ', podés cancelar la renovación en el menú "Renovación Automática"'
    }
  },
  failed: {
    subtitle: {
      system_error:
        'Ha ocurrido un error. <br /> Por favor inténtalo de nuevo mas tarde. <br /> Comunícate con nosotros vía Whatsapp al 50670027002 para ser asistido',
      invoice_error:
        'Has superado tu límite de crédito permitidos, puedes completar tu compra pagando con tarjeta. <br/> Comunícate con nosotros vía Whatsapp al 50670027002 para ser asistido'
    }
  }
}
